import { Component, Input } from '@angular/core';

const fallbackPicture = 'https://www.pphfoundation.ca/wp-content/uploads/2018/05/default-avatar.png';

@Component({
    selector: 'app-avatar',
    templateUrl: './avatar.component.html',
    styleUrls: ['./avatar.component.scss'],
})
export class AvatarComponent {
    @Input() initials?: string;
    @Input() picture?: string = fallbackPicture;
    @Input() size?: number = 36;

    get styles() {
        const styles = {
            width: `${this.size}px`,
            height: `${this.size}px`,
        };

        if (!this.initials) {
            styles['background-image'] = `url(${this.picture || fallbackPicture})`;
        }

        return styles;
    }
}
